import { PresenceEnum } from '@/models/ScheduledLessonReport';
import moment from 'moment';
import ScheduledLesson from '@/models/ScheduledLesson';
type ShowLessonArgs = {
  datetime?: string;
  presence?: PresenceEnum | null;
  lessonId?: number;
  nextLesson?: ScheduledLesson;
  hasDone?: boolean;
};
export const isBlockedLesson = ({
  datetime,
  hasDone,
  presence,
  nextLesson,
  lessonId,
}: ShowLessonArgs) => {
  if (!datetime && !hasDone && !presence) {
    return false;
  }

  if (!lessonId) return true;

  const isPastLesson = moment(datetime).isBefore(moment());
  const nextSevenDays =
    moment(datetime).isAfter(moment()) &&
    moment(datetime).isBefore(moment().add(7, 'days'));
  const isNextLesson = lessonId === nextLesson?.lesson.id;
  const hasPresence = presence === PresenceEnum.ATTENDED;

  const shouldShowLesson =
    isPastLesson ||
    hasPresence ||
    (nextSevenDays && !nextLesson) ||
    hasDone ||
    isNextLesson;

  return !shouldShowLesson;
};
